import React from 'react';

import cn from 'classnames';
import { noop, omit } from 'lodash';
import {
  string,
  arrayOf,
  shape,
  func,
  bool,
  oneOfType,
  element,
} from 'prop-types';

import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';

import ModalPropTypes, { ModalDefaultProps } from 'propTypes/ModalPropTypes';

import v from 'components/variables';

import s from './Wrapper.css';

const EXTRACTED_PROPS_MUI_APPBAR = [
  'moduleAccess',
  'profilePic',
  'router',
  'firstName',
  'lastName',
  'email',
  'showGoogleTranslate',
  'toggleGoogleTranslate',
  'shouldRenderAffiliationLink',
  'staticContext',
  'hideMenu',
  'isHovered',
  'hideModal',
  'isModalVisible',
  'isOnboarding',
  'mediaInfo',
  'preferredName',
  'refreshModalProps',
  'showModal',
  'user',
];

export default class Wrapper extends React.Component {
  render() {
    const { color, leftIcons, className, rightIcons, style, ...internal } =
      this.props;

    const {
      visibleMenu,
      setMenu,
      hideMenu,
      isPublicMemberPage,
      cancelHidingMenu,
      ...restProps
    } = internal;

    return (
      <MuiAppBar
        data-appbar="1"
        className={cn(s.container, className)}
        style={{
          background: v[`${color}XtraDark`],
          ...style,
        }}
        {...omit(restProps, EXTRACTED_PROPS_MUI_APPBAR)}
      >
        <Toolbar
          className={cn(s.toolbar, {
            [s.publicMemberToolbar]: isPublicMemberPage,
          })}
        >
          <div className={s.leftIcons}>{leftIcons}</div>
          <div className={s.rightIcons}>
            {rightIcons.map(icon =>
              !icon || !icon.constructor
                ? icon
                : React.cloneElement(icon, {
                    visibleMenu,
                    setMenu,
                    hideMenu,
                    cancelHidingMenu,
                  }),
            )}
            {visibleMenu}
          </div>
        </Toolbar>
      </MuiAppBar>
    );
  }
}

Wrapper.propTypes = {
  ...ModalPropTypes,
  className: string,
  color: string,
  firstName: string,
  isModalVisible: bool,
  isOnboarding: bool,
  isPublicMemberPage: bool,
  lastName: string,
  leftIcons: arrayOf(oneOfType([element, string])),
  mediaInfo: shape({}).isRequired,
  moduleAccess: shape({}),
  preferredName: string,
  profilePic: string,
  rightIcons: arrayOf(oneOfType([element, string])),
  shouldRenderAffiliationLink: bool,
  showGoogleTranslate: bool,
  style: shape({}),
  toggleGoogleTranslate: func,
  user: shape({}),
};

Wrapper.defaultProps = {
  ...ModalDefaultProps,
  color: 'green',
  leftIcons: [],
  rightIcons: [],
  style: {},
  className: undefined,
  firstName: null,
  isModalVisible: false,
  isOnboarding: false,
  isPublicMemberPage: false,
  lastName: null,
  moduleAccess: null,
  preferredName: null,
  profilePic: null,
  shouldRenderAffiliationLink: false,
  showGoogleTranslate: false,
  toggleGoogleTranslate: noop,
  user: null,
};
